export const highlight = (word: string): string => {
    return `<strong class="text-primary-500 font-inherit">${word}</strong>`
}
